import { Action } from '@ngrx/store';
import { TravelSearchToggles } from '@shared/store/models/travel-search-toggles';

export const RESTORE_TRAVEL_SEARCH_TOGGLES = '[Travel-Search-Toggles] Restore travel search toggles';
export const UPDATE_TRAVEL_SEARCH_TOGGLES = '[Travel-Search-Toggles] Update travel search toggles';
export const CLEAR_TRAVEL_SEARCH_TOGGLES = '[Travel-Search-Toggles] Clear travel search toggles';

export class RestoreTravelSearchToggles implements Action {
  readonly type = RESTORE_TRAVEL_SEARCH_TOGGLES;
}

export class UpdateTravelSearchToggles implements Action {
  readonly type = UPDATE_TRAVEL_SEARCH_TOGGLES;
  constructor(public payload: Partial<TravelSearchToggles>) {}
}

export class ClearTravelSearchToggles implements Action {
  readonly type = CLEAR_TRAVEL_SEARCH_TOGGLES;
}

// action types
export type TravelSearchTogglesAction =
  | RestoreTravelSearchToggles
  | UpdateTravelSearchToggles
  | ClearTravelSearchToggles;
